import React from 'react';
import './grid.css'

export const gridColumns = 12;

const Grid = ({flip = false, children}) => {
  return (
    <div className={`grid grid--${gridColumns}-col ${flip ? 'grid--flip' : ''}`}>
      {children}
    </div>
  )
}

export default Grid;


// WEBPACK FOOTER //
// ./src/components/Grid/index.js